// extracted by mini-css-extract-plugin
export default {"rootSlider":"CompoundSlider_rootSlider--ZEZ","container":"CompoundSlider_container--qc0"};